import { useState, useEffect, useRef } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

//Funciones comunes
import { LogErrors } from './../../utilities/LogErrors'
import { useLanguage } from './../../utilities/LanguageContext'
import { DeleteSessionInfo, DeleteSignUpInfo } from './../../utilities/BL/Sessions'
import { GetStatesContracted, GetNormalSchoolsByState, GetMajorsByNormalSchool, ReprintReceiptProcess } from './../../utilities/BL/SignUps'

//Componentes comunes
import { Input } from './../Commons/Forms/SignUp/Fields/Input'
import { Select } from './../Commons/Forms/SignUp/Fields/Select'
import { Loading } from './../Commons/Loading'
import { SignUpHeader } from './../Commons/Header/SignUpHeader'
import { GoToTop } from './../Commons/GoToTop'
import { GoToBack } from './../Commons/GoToBack'
import { SetDefaultWebTheme } from './../../utilities/BL/Settings'
import { Credits } from './../Commons/Footer/Credits'


const ReprintReceipt = () => {
    const { translate } = useLanguage()
    const navigate = useNavigate()
    const location = useLocation()

    const [normalStates, setNormalStates] = useState([])
    const [schools, setSchools] = useState([])
    const [majors, setMajors] = useState([])

    //Estados
    const [formData, setFormData] = useState({
        // Si viene un 'state' en la navegación con 'curpParam', lo usamos. Si no, queda vacío ''.
        curp: location.state?.curpParam || '',
        nameNormalState: '',
        normalState: '',
        nameNormalSchool: '',
        normalSchool: '',
        nameMajor: '',
        major: ''
    })
    
    const [errors, setErrors] = useState({})
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [isButtonLoading, setIsButtonLoading] = useState(false)

    //Objetos que almacenan los controles del formulario
    const curpRef = useRef(null)
    const normalStateRef = useRef(null)
    const normalSchoolRef = useRef(null)
    const majorsRef = useRef(null)

    //--- Funciones personalizadas ---//
    const LoadPage = async () => {
        try {
            await SetDefaultWebTheme()
            
            document.body.classList.remove('DarkTheme')
            document.getElementById("root").classList.add("BodyComplete")

            await DeleteSignUpInfo()

            //const session = await ValidateSession()
        
            // if (session.success) {
            //     navigate('/dashboard')
            // } else {
                const normalStatesRes = await GetStatesContracted()
                if (normalStatesRes.success) {
                    setNormalStates(normalStatesRes.data)
                }

                await DeleteSessionInfo()
            //}
        } catch (error) {
            await LogErrors('LoadPage - ReprintReceipt', error)
        } finally {
            setIsLoading(false)
        }
    }

    const GetSchoolName = async (schoolId) => {
        try {
            if (!schoolId || isNaN(schoolId)) return null
            const school = schools.filter(school => school.id === parseInt(schoolId))
            if (school.length === 0 || school[0].name === '') return ''
            return school[0].name
        } catch (error) {
            await LogErrors('GetSchoolName - ReprintReceipt', error)
        }
    }

    const GetNormalStateName = async (normalStateId) => {
        try {
            if (!normalStateId || isNaN(normalStateId)) return null
            const normalState = normalStates.filter(state => state.id === parseInt(normalStateId))
            if (normalState.length === 0 || normalState[0].name === '') return ''
            return normalState[0].name
        } catch (error) {
            await LogErrors('GetNormalStateName - ReprintReceipt', error)
        }
    }

    const GetMajorName = async (majorId) => {
        try {
            if (!majorId || isNaN(majorId)) return null
            const major = majors.filter(m => m.id === parseInt(majorId))
            if (major.length === 0 || major[0].name === '') return ''
            return major[0].name
        } catch (error) {
            await LogErrors('GetMajorName - ReprintReceipt', error)
        }
    }

    const ReprintProcess = async (e) => {
        try {
            e.preventDefault()
            setIsButtonLoading(true)

            // const session = await ValidateSession()
            
            // if (session.success) {
            //     navigate('/dashboard')
            // } else {
                setIsSubmitted(true)
                
                const formDataToSubmit = {
                    ...formData,
                    normalState: parseInt(formData.normalState) || null,
                    nameNormalState: await GetNormalStateName(formData.normalState),
                    normalSchool: parseInt(formData.normalSchool) || null,
                    nameNormalSchool: await GetSchoolName(formData.normalSchool),
                    major: parseInt(formData.major) || null,
                    nameMajor: await GetMajorName(formData.major)
                }
                
                const response = await ReprintReceiptProcess(formDataToSubmit, normalStates, schools, majors)
                
                if (response.success) {
                    navigate('/registered-applicant')
                } else {
                    if (typeof response.message === 'string') {
                        setErrors(response.message)
                    } else {
                        setErrors(response.message.formErrors)
                        
                        if (response.message.formErrors.curp) {
                            curpRef.current.focus()
                        } else if (response.message.formErrors.normalState) {
                            normalStateRef.current.focus()
                        } else if (response.message.formErrors.normalSchool) {
                            normalSchoolRef.current.focus()
                        } else if (response.message.formErrors.majors) {
                            majorsRef.current.focus()
                        }
                    }
                }
            //}
        } catch (error) {
            await LogErrors('ReprintProcess - ReprintReceipt', error)
        } finally {
            setIsButtonLoading(false)
        }
    }
    //--- Funciones personalizadas ---//

    //--- Eventos de la página web ---//
    useEffect(() => {
        LoadPage()
    },[]) 
    //--- Eventos de la página web ---//

    //--- Eventos de formulario ---//
    // const InputChange = async (e) => {
    //     try {
    //         const { id, value, type, checked } = e.target
    //         setFormData({
    //             ...formData,
    //             [id]: type === 'checkbox' ? checked : value
    //         })
    //     } catch (error) {
    //         await LogErrors('InputChange - ReprintReceipt', error)
    //     }
    // }

    /**
     * @param {Event} e 
    */
   const InputChange = async (e) => {
       try {
           let { id, value, type, checked } = e.target
           
           // --- 1. Reglas para la CURP ---
           if (id === 'curp') {
                // 1. Pasa a mayúsculas
                // 2. Reemplaza todo lo que no sea A-Z o 0-9 con un string vacío
                // 3. Limita la longitud máxima a 18 caracteres
                value = value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 18)
            }

            // --- 2. Reglas para Nombres y Apellidos (Title Case) ---
            if (id === 'name' || id === 'paternalSurname' || id === 'maternalSurname') {
                // Separamos la frase por espacios para evaluar cada palabra
                value = value.split(' ').map(word => {
                    if (word.length === 0) return word // Respetar dobles espacios accidentales mientras escriben
                    // Capitaliza la primera letra y asegura que el resto sea minúscula
                    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                }).join(' ')
            }

            setFormData({
                ...formData,
                [id]: type === 'checkbox' ? checked : value
            })
        } catch (error) {
            await LogErrors('InputChange - SignUp', error) // (Cambiar el nombre de la página según el componente)
        }
    }

    const NormalStateListChange = async (e) => {
        try {
            const stateId = e.target.value
       
            setFormData({
                ...formData,
                normalState: stateId,
                normalSchool: '', 
                major: '' 
            })
            
            const response = await GetNormalSchoolsByState(stateId)
            
            if (response.success) {
                setSchools(response.data)
            } else {
                setSchools([])
            }
            setMajors([]) 
        } catch (error) {
            await LogErrors('NormalStateListChange - ReprintReceipt', error)
        }
    }

    const SchoolListChange = async (e) => {
        try {
            const schoolId = e.target.value

            setFormData({
                ...formData,
                normalSchool: schoolId, 
                major: '' 
            })
            
            const response = await GetMajorsByNormalSchool(schoolId)
            
            if (response.success) {
                setMajors(response.data)
            } else {
                setMajors([])
            }
        } catch (error) {
            await LogErrors('SchoolListChange - ReprintReceipt', error)
        }
    }

    const MajorsListChange = async (e) => {
        try {
            setFormData({
                ...formData,
                major: e.target.value
            })
        } catch (error) {
            await LogErrors('MajorsListChange - ReprintReceipt', error)
        }
    }

    const FormSubmit = async (e) => {
        try {
            await ReprintProcess(e)
        } catch (error) {
            await LogErrors('FormSubmit - ReprintReceipt', error)
        }
    }

    const EnterKeyPressInForm = async (e) => {
        try {
            if (e.key === 'Enter') {
                await ReprintProcess(e)
            }
        } catch (error) {
            await LogErrors('EnterKeyPressInForm - ReprintReceipt', error)
        }
    }
    //--- Eventos de formulario ---//

    return (
        isLoading ? (
            <Loading />
        ) : (
            <>
                <SignUpHeader />
                <GoToBack url={'/'} className={'container'} />

                <main className='container Container-FullHeight Container-FlexContent SignUpMain'>
                    <div className='SignUpMain__Container'>
                        <form className='SignUpMain__Container__LoginForm' onSubmit={FormSubmit} onKeyPress={EnterKeyPressInForm}>
                            <p id='formTitle' className='SignUpMain__Container__LoginForm-Title'>Reimprimir comprobante</p> {/* Considerar usar traducción aquí */}
        
                            <label htmlFor='curp' className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.curp')}</label>
                            <Input
                                id='curp'
                                type='text'
                                value={formData.curp}
                                onChange={InputChange}
                                maxLength='18'
                                error={isSubmitted ? errors.curp : null} 
                                isSubmitted={isSubmitted} 
                                ref={curpRef}
                            />

                            <label htmlFor="normalState" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.normalState.label')}</label>
                            <Select
                                id="normalState"
                                value={formData.normalState}
                                onChange={NormalStateListChange}
                                options={normalStates}
                                placeholder={translate('labels.signUp.normalState.defaultOption')}
                                error={isSubmitted ? errors.normalState : null}
                                isSubmitted={isSubmitted}
                                ref={normalStateRef}
                            />

                            <label htmlFor="normalSchool" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.normalSchool.label')}</label>
                            <Select
                                id="normalSchool"
                                value={formData.normalSchool}
                                onChange={SchoolListChange}
                                options={schools} 
                                placeholder={translate('labels.signUp.normalSchool.defaultOption')}
                                error={isSubmitted ? errors.normalSchool : null}
                                disabled={!formData.normalState}
                                isSubmitted={isSubmitted}
                                ref={normalSchoolRef}
                            />

                            <label htmlFor="majors" className='SignUpMain__Container__LoginForm__Label'>{translate('labels.signUp.majors.label')}</label> 
                            <Select
                                id="majors"
                                value={formData.major} // Nota: Ajustado a major en lugar de majors para empalmar con el state
                                onChange={MajorsListChange} 
                                options={majors} 
                                placeholder={translate('labels.signUp.majors.defaultOption')}
                                error={isSubmitted ? errors.major : null}
                                disabled={!formData.normalSchool}
                                isSubmitted={isSubmitted}
                                ref={majorsRef}
                            />

                            {isButtonLoading ? (
                                <button type='button' className='SignUpMain__Container__LoginForm-Button SignUpMain__Container__LoginForm-Button-Disabled'>{translate('labels.signUp.loadingSubmit')}</button>
                            ) : (
                                <button type='submit' className='SignUpMain__Container__LoginForm-Button'>Consultar comprobante</button> // Considerar traducción
                            )}
                            {typeof errors === 'string' && <p className='error text-center text-danger'>{errors}</p>}
                        </form>

                        <hr className='SignUpMain__Container__Divisor'></hr>

                        <div className='SignUpMain__Container__Buttons'>
                            <button type='button' onClick={() => navigate('/')} className='SignUpMain__Container__Buttons__Button--Disabled'>{translate('labels.signUp.login')}</button>
                        </div>

                        <div className='Login-Partners'>
                            <img src='/img/brand/dgesum-logotipo.png' alt='Logotipo-DEGESuM' className='Login-Partners-Logo' />
                            <img src='/img/brand/upn-logotipo.png' className='Login-Partners-Logo Login-Partners-Logo--UPN' />
                            <img src='/img/brand/edutest-logotipo.png' alt='Logotipo-EDUTEST' className='Login-Partners-Logo' />
                        </div>
                    </div>
                </main>
        
                <GoToTop />

                <footer className='Login-Footer'>
                    <Credits />
                </footer>
            </>
        )
    )
}

export { ReprintReceipt };